import { render } from "./Datenschutz.vue?vue&type=template&id=2e78a640&scoped=true"
const script = {}

import "./Datenschutz.vue?vue&type=style&index=0&id=2e78a640&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e78a640"]])

export default __exports__